import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import moment from "moment";
import { withAuthentication, SubHeading, withProvidersApi, FormTabs, FormTab } from "cw-styleguide-react";
import withAssets from "../../../components/hoc/withAssets";
import CoursesDetailsForm from "./CoursesDetailsForm";
import CoursesSessionsForm from "./CoursesSessionsForm";
import CoursesQualificationsForm from "./CoursesQualificationsForm";
import CoursesClassificationsForm from "./CoursesClassificationsForm";
import i18n from "../../../i18n";
import {
  ROLE_STAFF,
  ROLE_PROVIDER,
  COURSE_TITLE_FIELD_COURSE,
  COURSE_TITLE_FIELD_QUALIFICATION,
  LANGUAGE_EN,
  TAB_COURSE_DETAILS,
  TAB_COURSE_SESSIONS,
  TAB_COURSE_QUALIFICATIONS,
  TAB_COURSE_CLASSIFICATIONS,
  OPERATION_EDIT
} from '../../../constants';

class CoursesCreateEditForm extends Component {

  constructor(props) {
    super(props);

    this.scrollReference = React.createRef();

    this.handleScrollTop = this.handleScrollTop.bind(this);
  }

  componentDidMount() {
    if (this.props.authentication.hasRole(ROLE_PROVIDER)) {
      // Set the main provider based on authenticated user.
      this.props.providersApiGetProvider(this.props.authentication.getClaim('atlasAccountId'), 'name', i18n.language, (response) => {
        this.props.handleSet({
          mainProviderId: response.data.atlasAccountId,
          mainProviderLabel: response.data.providerName
        });
      }, (error) => {
        console.error(error);
      });
    }

    // if (this.props.location.hash) {
    //   let element = document.getElementById('startDate');

    //   if (element) {
    //     element.scrollIntoView();
    //   }
    //   console.log(element);
    // }
  }

  // componentDidUpdate(prevProps) {
  //   if (this.props.location.hash !== prevProps.location.hash) {
  //     let element = document.getElementById('startDate');

  //     if (element) {
  //       element.scrollIntoView();
  //     }
  //     console.log(element);
  //   }

  // }

  handleScrollTop() {
    this.scrollReference.current.scrollIntoView({ behavior: 'smooth' });
  }

  render() {
    return (
      <Fragment>
        {this.props.mode === OPERATION_EDIT &&
          <Fragment>
            {this.props.status &&
              <p><strong>{this.props.t('local:view.courses.edit.field.currentStatus.label')}</strong>: {this.props.courses.getStatusName(this.props.status)}</p>
            }
            {this.props.audit && this.props.audit.createdBy &&
              <p><strong>{this.props.t('local:view.courses.edit.field.createdBy.label')}</strong>: {this.props.audit.createdBy.name} {moment(this.props.audit.dateCreated).format("DD/MM/YYYY HH:mm:ss")}</p>
            }
            {this.props.audit && this.props.audit.updatedBy &&
              <p><strong>{this.props.t('local:view.courses.edit.field.updatedBy.label')}</strong>: {this.props.audit.updatedBy.name} {moment(this.props.audit.dateUpdated).format("DD/MM/YYYY HH:mm:ss")}</p>
            }
            {this.props.qaDate &&
              <p><strong>{this.props.t('local:view.courses.edit.field.qaDate.label')}</strong>: {moment(this.props.qaDate).format("DD/MM/YYYY HH:mm:ss")}</p>
            }
          </Fragment>
        }
        <div ref={this.scrollReference} />
        <SubHeading type={'sub-heading-small'} colour={'sub-heading-small--b'}>
          {this.props.inputLanguage === LANGUAGE_EN ? this.props.t('styleguide:languages.englishVersion') : this.props.t('styleguide:languages.welshVersion')}
        </SubHeading>
        <FormTabs active={this.props.errorActiveTab}>
          <FormTab id={TAB_COURSE_DETAILS} label={this.props.t('local:view.courses.create.tabs.courseDetails.label')} onClick={(e) => this.props.errorActiveTab !== TAB_COURSE_DETAILS && this.props.handleClearActiveErrors()}>
            <CoursesDetailsForm
              mode={this.props.mode}
              titleField={this.props.titleField}
              title_en={this.props.title_en}
              title_cy={this.props.title_cy}
              qualificationTitleId={this.props.qualificationTitleId}
              qualificationTitleLabel={this.props.qualificationTitleLabel}
              qualificationTitleLabel_en={this.props.qualificationTitleLabel_en}
              qualificationTitleLabel_cy={this.props.qualificationTitleLabel_cy}
              qualifications={this.props.qualifications}
              mainProviderId={this.props.mainProviderId}
              mainProviderLabel={this.props.mainProviderLabel}
              abbreviatedTitle_en={this.props.abbreviatedTitle_en}
              abbreviatedTitle_cy={this.props.abbreviatedTitle_cy}
              courseGroupId={this.props.courseGroupId}
              courseGroupLabel={this.props.courseGroupLabel}
              courseGroupTypeId={this.props.courseGroupTypeId}
              summary_en={this.props.summary_en}
              summary_cy={this.props.summary_cy}
              content_en={this.props.content_en}
              content_cy={this.props.content_cy}
              programme={this.props.programme}
              duration_en={this.props.duration_en}
              duration_cy={this.props.duration_cy}
              entry_en={this.props.entry_en}
              entry_cy={this.props.entry_cy}
              additionalDetails_en={this.props.additionalDetails_en}
              additionalDetails_cy={this.props.additionalDetails_cy}
              enrolment_en={this.props.enrolment_en}
              enrolment_cy={this.props.enrolment_cy}
              cost_en={this.props.cost_en}
              cost_cy={this.props.cost_cy}
              languages={this.props.languages}
              courseType={this.props.courseType}
              reviewDate={this.props.reviewDate}
              sessions={this.props.sessions}
              errors={this.props.formErrors}
              errorActiveField={this.props.errorActiveField}
              inputLanguage={this.props.inputLanguage}
              location={this.props.location}
              handleChange={this.props.handleChange}
              handleSet={this.props.handleSet}
              handleSetTitleField={this.props.handleSetTitleField}
              handleClearActiveErrors={this.props.handleClearActiveErrors} />
          </FormTab>
          <FormTab id={TAB_COURSE_SESSIONS} label={this.props.t('local:view.courses.create.tabs.sessions.label')} onClick={(e) => this.props.errorActiveTab !== TAB_COURSE_SESSIONS && this.props.handleClearActiveErrors()}>
            <CoursesSessionsForm
              mode={this.props.mode}
              sessions={this.props.sessions}
              sessionId={this.props.sessionId}
              startDate={this.props.startDate}
              startDetails_en={this.props.startDetails_en}
              startDetails_cy={this.props.startDetails_cy}
              daysTimes_en={this.props.daysTimes_en}
              daysTimes_cy={this.props.daysTimes_cy}
              studyMethodType={this.props.studyMethodType}
              studyMethodHours={this.props.studyMethodHours}
              studyMethodTimes={this.props.studyMethodTimes}
              mainProviderId={this.props.mainProviderId}
              contactId={this.props.contactId}
              contactLabel={this.props.contactLabel}
              contacts={this.props.contacts}
              venueId={this.props.venueId}
              venueLabel={this.props.venueLabel}
              venueContactId={this.props.venueContactId}
              venueContactLabel={this.props.venueContactLabel}
              venues={this.props.venues}
              errors={this.props.formErrors}
              errorActiveField={this.props.errorActiveField}
              errorActiveSessionStep={this.props.errorActiveSessionStep}
              errorActiveSessionId={this.props.errorActiveSessionId}
              inputLanguage={this.props.inputLanguage}
              location={this.props.location}
              handleChange={this.props.handleChange}
              handleSet={this.props.handleSet}
              handleClearActiveErrors={this.props.handleClearActiveErrors}
              handleScrollTop={this.handleScrollTop} />
          </FormTab>
          <FormTab id={TAB_COURSE_QUALIFICATIONS} label={this.props.t('local:view.courses.create.tabs.qualifications.label')} onClick={(e) => this.props.errorActiveTab !== TAB_COURSE_QUALIFICATIONS && this.props.handleClearActiveErrors()}>
            <CoursesQualificationsForm
              qualificationId={this.props.qualificationId}
              qualificationLabel={this.props.qualificationLabel}
              qualifications={this.props.qualifications}
              unknownQualifications={this.props.unknownQualifications}
              manualQualificationId={this.props.manualQualificationId}
              qualificationTitle_en={this.props.qualificationTitle_en}
              qualificationTitle_cy={this.props.qualificationTitle_cy}
              qualificationType={this.props.qualificationType}
              qualificationLevel={this.props.qualificationLevel}
              awardingBody={this.props.awardingBody}
              manualQualifications={this.props.manualQualifications}
              errors={this.props.formErrors}
              errorActiveField={this.props.errorActiveField}
              errorActiveQualificationStep={this.props.errorActiveQualificationStep}
              errorActiveQualificationId={this.props.errorActiveQualificationId}
              inputLanguage={this.props.inputLanguage}
              location={this.props.location}
              handleChange={this.props.handleChange}
              handleSet={this.props.handleSet}
              handleClearActiveErrors={this.props.handleClearActiveErrors}
              handleScrollTop={this.handleScrollTop} />
          </FormTab>
          {/* @TODO: Find cleaner way for conditionally including form tabs */}
          {this.props.authentication.hasRole(ROLE_STAFF) ?
            <FormTab id={TAB_COURSE_CLASSIFICATIONS} label={this.props.t('local:view.courses.create.tabs.classifications.label')} onClick={(e) => this.props.handleClearActiveErrors()}>
              <CoursesClassificationsForm
                classificationId={this.props.classificationId}
                classificationLabel={this.props.classificationLabel}
                classifications={this.props.classifications}
                addClassification={this.props.addClassification}
                errors={this.props.formErrors}
                errorActiveField={this.props.errorActiveField}
                inputLanguage={this.props.inputLanguage}
                location={this.props.location}
                handleChange={this.props.handleChange}
                handleSet={this.props.handleSet}
                handleClearActiveErrors={this.props.handleClearActiveErrors} />
            </FormTab>
            : <Fragment></Fragment>}
        </FormTabs>
      </Fragment>
    );
  }

}

export default withProvidersApi(process.env)(withAssets(withAuthentication(withTranslation('local')(CoursesCreateEditForm))));
